export default __webpack_public_path__ + "static/media/watermark_logo.2eabe0aa.svg";